import { ArrowRight, Activity, Award, Users, MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
export default function HeroDelCurso() {
  return <section id="hero-del-curso" className="relative w-full py-[120px] bg-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_40%,var(--color-primary)_0%,transparent_40%)] opacity-15 pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="lg:col-span-6 flex flex-col items-start z-20">
            <Badge variant="outline" className="font-mono text-primary border-primary/30 bg-primary/10 mb-8 px-4 py-1.5 text-sm tracking-wide">
              CURSO PROFESIONAL
            </Badge>
            
            <h1 className="font-sans font-extrabold text-5xl sm:text-6xl lg:text-7xl tracking-tight text-background mb-6 leading-[1.05]">
              Domina la <br />
              <span className="text-primary">Kinesiología</span> <br />
              Deportiva
            </h1>
            
            <p className="text-muted text-lg sm:text-xl mb-10 max-w-lg leading-relaxed">
              Fórmate con expertos en el campo y lleva tu carrera al siguiente nivel con nuestro programa intensivo, diseñado para la excelencia clínica y el alto rendimiento.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Link to="https://mpago.la/1WfMEZk" newTab className="w-full sm:w-auto">
                <Button size="lg" className="w-full sm:w-auto group text-base font-semibold h-12 bg-[#009EE3] hover:bg-[#008ED2] text-white border-none shadow-md transition-all duration-300 hover:scale-105">
                  Inscribirme Ahora
                  <ArrowRight className="ml-2 size-5 group-hover:translate-x-1 transition-transform" />
                </Button>
              </Link>
              <Link to="https://wa.me/59896344395" newTab className="w-full sm:w-auto">
                <Button size="lg" className="w-full sm:w-auto group text-base font-semibold h-12 bg-[#25D366] hover:bg-[#22c35e] text-white border-none shadow-md transition-all duration-300 hover:scale-105">
                  <MessageCircle className="mr-2 size-5" />
                  Consultar WhatsApp
                </Button>
              </Link>
            </div>

            {}
            <div className="grid grid-cols-2 gap-6 mt-16 pt-8 border-t border-background/10 w-full max-w-md">
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2 text-background font-bold text-2xl">
                  <Users className="size-6 text-primary" />
                  <span>+500</span>
                </div>
                <span className="text-muted text-sm font-medium">Alumnos Egresados</span>
              </div>
              <div className="flex flex-col gap-1">
                <div className="flex items-center gap-2 text-background font-bold text-2xl">
                  <Award className="size-6 text-primary" />
                  <span>100%</span>
                </div>
                <span className="text-muted text-sm font-medium">Práctica Clínica</span>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-6 relative h-[500px] lg:h-[750px] w-full mt-8 lg:mt-0">
            
            {}
            <div className="absolute -left-32 top-1/4 w-80 h-[110%] bg-background/5 backdrop-blur-xl border border-background/10 rounded-[60px] -rotate-12 z-20 hidden lg:block pointer-events-none shadow-2xl" />
            
            {}
            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-2xl shadow-black/50">
              {}
              <div className="absolute inset-0 bg-primary/25 mix-blend-color z-10 pointer-events-none" />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground/80 via-transparent to-transparent z-10 pointer-events-none" />
              
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1583410/img/kinesiologist_knee_treatment_action.png" alt="Kinesiólogo profesional realizando tratamiento en la rodilla de un atleta" className="absolute inset-0 w-full h-full object-cover object-center scale-105 transition-transform duration-1000 hover:scale-100" />
            </div>

            {}
            <div className="absolute bottom-8 right-8 bg-background/10 backdrop-blur-md border border-background/20 p-5 rounded-2xl z-30 max-w-[240px] shadow-xl">
              <div className="flex items-start gap-4">
                <div className="size-12 rounded-full bg-primary/20 flex items-center justify-center shrink-0">
                  <Activity className="text-primary size-6" />
                </div>
                <div>
                  <p className="text-background font-bold text-base leading-tight mb-1">Técnicas Avanzadas</p>
                  <p className="text-muted text-xs leading-relaxed">Aprende las últimas metodologías en rehabilitación deportiva.</p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}